document.addEventListener('DOMContentLoaded', e => {
	const prod_form = document.querySelector('[data-product-form-regular]');
	if (prod_form) {
		const var_selector = prod_form.querySelector('[data-variant-selection]');
		if (var_selector) {
			let CURR_ID = var_selector.getAttribute('variant');
			// Empire doesn't fire an event when a variant has changed, so we have to find our own
			const selector_obsrvr = new MutationObserver((list, _obsrvr) => {
				// TODO: Tighten this up a bit
				if (list[0]?.attributeName == 'variant') {
					const new_var_id = var_selector.getAttribute('variant');
					if (new_var_id != CURR_ID) {
						CURR_ID = new_var_id;
						const body = document.querySelector('body');
						body.dispatchEvent(new CustomEvent(
							'empire-shopify-product-variant-changed',
							{
								bubbles: true,
								detail: {
									variant: new_var_id,
								}
							}),
						);
					}
				}
			});
			selector_obsrvr.observe(var_selector, {attributes: true});
		}
	}
});
